<template lang="pug">
footer
  .content
    .flex.items-start.justify-between
      .col-8.connten-left
        //- h3 CÔNG TY TNHH CÔNG NGHỆ MẠNG THÔNG TIN VIỆT NAM

        h3 ติดต่อเรา
        ul.list-reset
          li.flex.items-start
            label.item-label อีเมลล์:
            .item-content thaidaily2020@gmail.com
          li.flex.items-start
            label.item-label Line:
            .item-content thaidaily777
          li.flex.items-start
            label.item-label ที่อยู่ :
            .item-content 388/64 Nuan Chan Rd, Nuanchan, Bueng Kum, Bangkok 10230.
      //- .col-4
      //-   h3 ติดต่อเรา
      //-   ul.list-reset
      //-     li.flex.items-start
      //-       label.item-label อีเมลล์:
      //-       .item-content thaidaily2020@gmail.com
      //-     li.flex.items-start
      //-       label.item-label Line:
      //-       .item-content thaidaily777
          //- li.flex.items-start(style="font-size: 20px; margin-top: 10px; color: yellow;cursor: pointer;", @click="handleClick") Cơ hội nghề nghiệp
    //- .col-12
      //- p.small.my0 Giấy phép thiết lập trang thông tin điện tử tổng hợp trên mạng Số 44/GP – STTTT do Sở Thông tin và Truyền thông Thành phố Hồ Chí Minh cấp ngày 13/9/2017
      //- p.small.my0 Chịu trách nhiệm nội dung:  Lê Phạm Huyền Nhung
</template>

<script>
export default{
  name: 'footer',
  methods:{
      handleClick() {
        this.$router.push('/want')
      }
  },
  data () {
    return {
    }
  }
}
</script>


<style lang="stylus" scoped>
@import '../assets/variables.styl'
footer
  padding 10px
  background-color $color-primary
  color white
  .content
    limit-width()
    .item-label
      display inline-block
      width 120px
    .item-content
      display inline-block
    .font18
        font-size:18px;
        color:#fff;
</style>



// WEBPACK FOOTER //
// Footer.vue?1dffd530